<template>
  <el-dialog
    :visible="!!current"
    fullscreen
    class="unknown-files-modal"
    @close="setCurrent()"
  >
    <el-row type="flex">
      <el-col :span="12">
        <el-divider content-position="left">JPG/JPEG</el-divider>
        <div v-if="current" ref="lazy" class="hardware-image-lazy">
          <img-actions
            v-for="file in current.files"
            :key="file.id"
            :file="file"
            :container="$refs.lazy"
            :type="activeType"
            @zoom="handleZoom"
          />
        </div>
      </el-col>
      <el-col :span="12" class="right">
        <el-row class="mb-20">
          <h3 class="mt-0">Последний обработанный мной файл</h3>
          <template v-if="lastEdited">
            <span class="mr-40">
              Тип: {{ getType(lastEdited.document_type) }}
            </span>
            <span v-if="lastEdited.document_number" class="mr-40">
              №{{ lastEdited.document_number }}
            </span>
            <span v-if="lastEdited.document_date">
              от
              {{
                dateToFormat(lastEdited.document_date, 'onlyDateWithFullTear')
              }}
            </span>
          </template>
          <span v-else>Нет данных</span>
        </el-row>
        <el-row class="mb-20">
          <el-select
            v-model="active"
            placeholder="Выберите тип файла"
            size="small"
            class="w-300"
          >
            <el-option
              v-for="(item, index) in fileTypes"
              :key="item.type"
              :label="item.label"
              :value="index"
            />
          </el-select>
        </el-row>
        <component :is="components[active]" :type="activeType" />
      </el-col>
    </el-row>
    <img-viewer :visible="!!url" :url="url" @close="url = ''" />
  </el-dialog>
</template>

<script>
import { components, fileTypes } from '../constants'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ImgActions from '@/views/UnknownFiles/components/ImgActions'
import ImgViewer from '@/components/Modals/ImgViewer'
import TtnFileType from './TtnFileType'
import UnknownOrCopy from './UnknownOrCopy'

export default {
  name: 'UnknownFileModal',
  components: { UnknownOrCopy, TtnFileType, ImgActions, ImgViewer },
  data() {
    return {
      fileTypes,
      components,
      active: undefined,
      url: '',
      lastEdited: null,
    }
  },
  computed: {
    ...mapGetters('hardware', ['current']),
    activeType() {
      return this.fileTypes[this.active]?.type
    },
  },
  watch: {
    current(val) {
      this.active = undefined
      this.url = ''
      this.lastEdited = null

      if (val) {
        this.setLastEdited()
      }
    },
  },
  methods: {
    ...mapActions('hardware', ['getLastEdited']),
    ...mapMutations('hardware', ['setCurrent']),
    handleZoom(url) {
      this.url = url
    },
    setLastEdited() {
      this.getLastEdited()
        .then(res => {
          if (res?.document_type) {
            this.lastEdited = res
          }
        })
        .catch(err => this.errHandler(err))
    },
    getType(type) {
      return type === 'ttns' ? 'ТТН' : type
    },
  },
}
</script>

<style lang="sass">
.unknown-files-modal
  .el-dialog__header
    padding: 0
  .el-dialog__body
    padding: 20px 70px 20px 10px
  .el-divider--horizontal
    margin: 10px 0
  .hardware-image-lazy
    height: calc(100vh - 61px)
    overflow-y: auto
  .right
    padding-left: 40px
    .w-300
      width: 300px
    .mt-0
      margin-top: 0
    .mr-40
      margin-right: 40px
    .mb-20
      margin-bottom: 20px
</style>
